export default __webpack_public_path__ + "static/media/cocoa.4dde30fe.jpg";